import { inject, Injectable } from '@angular/core';
import { BaseApiService } from '../base';
import { Observable } from 'rxjs';
import { IBalance, IExtendedBalance } from '@domain/balance';

@Injectable({
  providedIn: 'root',
})
export class BalanceApiService {
  readonly #baseApi = inject(BaseApiService);

  public getBalance(): Observable<IBalance> {
    return this.#baseApi.get<IBalance>('/balance');
  }

  public getBalanceExtended(): Observable<IExtendedBalance> {
    return this.#baseApi.get<IExtendedBalance>('/balance/extended');
  }
}
